// extracted by mini-css-extract-plugin
export default {"textAlignment":"tBYkp0","moreOptions":"ETMXUb","mobileMoreOptions":"sxacc0"};